import React from 'react'
import { Helmet } from 'react-helmet-async'
import Header from '../components/Header'
import Footer from '../components/Footer'
import PageMeta from '../components/PageMeta'

const AboutPage = () => {
  return (
    <div>
      <PageMeta 
        title="About RDS Studio | Web Design Agency Centurion, Pretoria — Gauteng"
        description="Meet the RDS Studio team — your local web design agency in Centurion, Gauteng. Boutique digital agency specialising in custom WordPress websites, SEO & digital marketing. Serving Centurion, Pretoria & beyond."
        canonical="https://rdsstudio.co.za/about"
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "@id": "https://rdsstudio.co.za/#organization",
            "name": "RDS Studio",
            "alternateName": "Responsive Design Solutions",
            "description": "South African boutique digital agency specialising in web development, digital marketing, automation and SEO. Based in Centurion, delivering enterprise-level digital solutions to clients across South Africa and internationally through skilled specialists and strategic partnerships.",
            "foundingDate": "2014",
            "knowsAbout": [
              "Web Development",
              "WordPress Development",
              "React Development",
              "Digital Marketing",
              "SEO Optimization",
              "Google Ads Management",
              "Private Cloud Solutions",
              "Nextcloud",
              "VPS Server Management",
              "Node.js Development",
              "JavaScript",
              "HTML/CSS",
              "WooCommerce",
              "Social Media Marketing",
              "Content Strategy",
              "Technical SEO",
              "UI/UX Design"
            ],
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Centurion",
              "addressRegion": "Gauteng",
              "addressCountry": "ZA"
            },
            "url": "https://rdsstudio.co.za",
            "email": "info@rdsstudio.co.za",
            "telephone": "+27846390621",
            "sameAs": [
              "https://www.facebook.com/profile.php?id=61579996723546",
              "https://www.instagram.com/rdsstudio1111/",
              "https://www.linkedin.com/in/jean-pierre-matthys-du-toit-7671493a3/",
              "https://www.youtube.com/channel/UCqEgC_kMwk4MqEcIC_yCayw"
            ]
          })}
        </script>
      </Helmet>
      <Header />
      <main className="main-content">
        <section className="section about">
          <div className="section-inner">
            <h1 className="title title-h2">About<br/>RDS Studio</h1>
            <p className="description">RDS Studio is a boutique digital agency based in Centurion, specialising in web development, digital marketing, intelligent automation, and cloud infrastructure. Our experienced team helps South African and international businesses build powerful online presences through custom websites, strategic marketing campaigns, and cutting-edge automation solutions.</p>

            <h2>Why Choose RDS Studio</h2>
            <div className="about-content">
              <div className="about-text">
                <h3>Expert Team, Personal Service</h3>
                <p>When you partner with RDS Studio, you work directly with senior developers and strategists -- not account managers or junior staff. This ensures clear communication, faster decision-making, and consistent project leadership from discovery to launch.</p>
                <h3>Proven Track Record</h3>
                <p>Across a wide portfolio of successful projects spanning business websites, e-commerce platforms, private cloud infrastructure, marketing automation systems, and comprehensive SEO campaigns, we combine technical expertise with strategic thinking to deliver measurable results that drive growth.</p>
                <h3>Quality-First Philosophy</h3>
                <p>We maintain selective project capacity to ensure every client receives dedicated attention and exceptional service. Each website, campaign, and infrastructure deployment undergoes rigorous testing and quality assurance before launch -- guaranteeing professional standards and long-term reliability.</p>
                <h3>Comprehensive Digital Services</h3>
                <ul>
                  <li>Custom web development (WordPress, React, modern JavaScript frameworks)</li>
                  <li>Private cloud infrastructure using Nextcloud and enterprise VPS solutions</li>
                  <li>Server configuration, security hardening, and ongoing maintenance</li>
                  <li>Digital marketing strategy and paid advertising campaign management</li>
                  <li>Technical SEO audits, on-page optimization, and organic growth strategies</li>
                  <li>Ongoing website maintenance, security updates, and technical support</li>
                </ul>
              </div>
            </div>

            <h2 style={{ marginTop: '4rem' }}>Our Story</h2>
            <p>RDS Studio was built on a clear vision: to give South African businesses access to enterprise-quality digital services at competitive rates. From our roots as a web development studio, we've grown into a comprehensive boutique agency serving clients across South Africa and internationally. Our expansion into digital marketing, intelligent automation, and privacy-focused cloud solutions reflects our commitment to staying ahead of industry trends — helping businesses maintain control over their digital assets while leveraging the latest technology.</p>

            <h2 style={{ marginTop: '3rem' }}>Strategic Partnerships</h2>
            <p>For specialized requirements such as advanced UI/UX design, professional copywriting, or niche technical development, we collaborate with our network of vetted specialists. These strategic partnerships allow us to scale our capabilities while maintaining our commitment to quality and consistent project management. You always have a single point of contact at RDS Studio throughout your project lifecycle.</p>

            <h2 style={{ marginTop: '3rem' }}>Let's Build Something Great</h2>
            <p>Ready to elevate your digital presence? <a href="/contact" style={{ color: 'var(--color-secondary)', textDecoration: 'underline' }}>Contact our team</a> for a complimentary consultation about your web development, automation, or digital marketing objectives. We'll provide honest assessments and strategic recommendations tailored to your business goals.</p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}

export default AboutPage
